<template>
  <div :class="styleMain">
    <actions-header :match="match" :statusFilter="statusFilter"/>
    <ul>
      <action v-for="action in actions" :key="action.id" :action="action" v-show="!statusFilter || action.statusId === statusFilter"/>
    </ul>
  </div>
</template>

<script>
import Action from './action/Action'
import ActionsHeader from './ActionsHeader'

export default {
  name: 'SportFootballMatchActions',
  components: { Action, ActionsHeader },
  props: {
    match: Object,
    statusFilter: {
      required: false,
      type: Number
    }
  },
  data () {
    return {
      styleLoaded: null
    }
  },
  computed: {
    actions () { return this.$store.getters['Sport/Football/Match/actionsSorted'](this.match?.id) },

    styleMain () { return ['sportFootballMatchActions', this.styleLoaded] }
  },
  updated () {
    this.styleLoaded = 'loaded'
  }
}
</script>

<style>
.sportFootballMatchActions{
  display:flex;
  flex: 1 1 auto;
  overflow:hidden;
  flex-direction: column;
  position:relative;
  box-sizing: border-box;
  width:100%;
}
.sportFootballMatchActions ul{
  flex: 1 1 auto;
  margin:0;
  padding: 0;
  list-style: none;
  padding:10px;
  overflow-y:auto;
  opacity: 0;
  transition-duration: 1s;
  transition-property: opacity;
  background-color:white;
  box-sizing: border-box;
  height:100%;
}
.sportFootballMatchActions.loaded ul{
  opacity: 1;
}
</style>
